import TextField from "../../../components/fields/textField/TextField.vue";
import { ExercicioService } from "../../../services/ExercicioService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";

export default {
    components: {
        TextField,
        Breadcrumb,
    },
    name: "CriarExercicio",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Exercícios',
                disabled: false,
                href: '/gerenciar-exercicios'
            },
            {
                text: 'Cadastro de Exercício',
                disabled: true
            }
        ],
        exercicio: {
            ano: '',
            ativo: false
        },
        loading: false,
    }),
    methods: {
        submitForm() {
            this.$refs.form.validate();
            if (!this.$refs.form.$invalid) {
              this.salvarExercicio();
            }
        },
        async salvarExercicio() {

            const isValid = this.$refs.form.validate();

            if (!isValid) {
                return false;
            }

            this.loading = true;

            const formData = new FormData();

            formData.append("ano", this.exercicio.ano);
            formData.append("ativo", this.exercicio.ativo ? 1 : 0);

            await ExercicioService.store(formData);

            this.$emit('exercicio-salvo');
            this.close();
        },
        async close() {
            this.exercicio.ano = '';
            this.exercicio.ativo = false;
            this.loading = false;
            this.$emit("on-close");
        }
    }
};
